import { NotificationPreferencesApiClient } from '@fourthwall/services/dist/NotificationPreferencesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useNotificationPreferencesMutation = createMutationHook(
  NotificationPreferencesApiClient.updateNotificationPreferences,
  {
    mutationKey: ['notificationPreferences'],
  },
)
